module.exports = "/static/images/logo.png";